var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPrint = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 2.15991H5.4V6.60436H18.6V2.15991ZM19.7 12.1599C19.4083 12.1599 19.1285 12.0428 18.9222 11.8345C18.7159 11.6261 18.6 11.3435 18.6 11.0488C18.6 10.7541 18.7159 10.4715 18.9222 10.2631C19.1285 10.0548 19.4083 9.93769 19.7 9.93769C19.9917 9.93769 20.2715 10.0548 20.4778 10.2631C20.6841 10.4715 20.8 10.7541 20.8 11.0488C20.8 11.3435 20.6841 11.6261 20.4778 11.8345C20.2715 12.0428 19.9917 12.1599 19.7 12.1599ZM16.4 19.9377H7.6V14.3821H16.4V19.9377ZM19.7 7.71547H4.3C3.42479 7.71547 2.58542 8.06666 1.96655 8.69178C1.34768 9.3169 1 10.1647 1 11.0488V17.7155H5.4V22.1599H18.6V17.7155H23V11.0488C23 10.1647 22.6523 9.3169 22.0335 8.69178C21.4146 8.06666 20.5752 7.71547 19.7 7.71547Z",
    fill: "#32008E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrint, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/print.ec50af27.svg";
export { ForwardRef as ReactComponent };